export default __webpack_public_path__ + "static/media/1_3.7db8ceb9.jpg";